import { Routes } from '@angular/router';
import { RedirectGuard } from './_guards/redirect.guard';
import { NotFoundComponent } from './features/not-found/not-found.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [RedirectGuard],
    pathMatch: 'full',
    component: NotFoundComponent,
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./features/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: 'assessments',
    loadChildren: () =>
      import('./features/assessments/assessments.module').then(
        (m) => m.AssessmentsModule
      ),
  },
  {
    path: 'flow-insert-key',
    loadChildren: () =>
      import('./features/flow-insert-key/flow-insert-key.module').then(
        (m) => m.FlowInsertKeyModule
      ),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
